// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 767.98px) {
  .page-wrapper .page-header .header-wrapper .nav-right > ul > li .profile-media .flex-grow-1 {
    display: none !important;
  }
  .page-wrapper .page-header .header-wrapper .nav-right > ul > li {
    padding: 6px 8px;
  }
}
.page-wrapper:has(.platform-pause-notice) .page-body-wrapper > .page-body {
  margin-top: calc(var(--page-header-height, 80px) + var(--platform-pause-notice-height, 0px)) !important;
}

.page-wrapper:has(.platform-pause-notice) .page-body-wrapper > .sidebar-wrapper .sidebar-main {
  padding-top: var(--platform-pause-notice-height, 0px);
}`, "",{"version":3,"sources":["webpack://./src/layout/header/header.scss"],"names":[],"mappings":"AAAA;EACE;IACE,wBAAA;EACF;EAEA;IACE,gBAAA;EAAF;AACF;AAGA;EACE,uGAAA;AADF;;AAIA;EACE,qDAAA;AADF","sourcesContent":["@media (max-width: 767.98px) {\n  .page-wrapper .page-header .header-wrapper .nav-right > ul > li .profile-media .flex-grow-1 {\n    display: none !important;\n  }\n\n  .page-wrapper .page-header .header-wrapper .nav-right > ul > li {\n    padding: 6px 8px;\n  }\n}\n\n.page-wrapper:has(.platform-pause-notice) .page-body-wrapper > .page-body {\n  margin-top: calc(var(--page-header-height, 80px) + var(--platform-pause-notice-height, 0px)) !important;\n}\n\n.page-wrapper:has(.platform-pause-notice) .page-body-wrapper > .sidebar-wrapper .sidebar-main {\n  padding-top: var(--platform-pause-notice-height, 0px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
